<div
  class="button-wrapper global-transition"
  (click)="handleClick()"
  [style.height.px]="height"
  [ngClass]="{
    'orange-button': isOrangeButton,
    'red-button': isRedButton,
    'white-button': isWhiteButton,
    'blue-button': isBlueButton,
    'grey-button': isGreyButton,
    'light-grey-button': isLightGreyButton,
    'green-button': isPrimary || !isOrangeButton,
    'disabled-button': disabled
  }">
  <button
    [type]="type"
    class="button btn"
    [ngClass]="{
      'button-with-loader': isDataSavingActive && showSmallSpinner,
      'disabled': disabled
    }">
    <div class="btn-flex">
      <div class="small-loader" [ngStyle]="{'border-top-color': '#ffffff'}" *ngIf="isDataSavingActive && showSmallSpinner"></div>
      <nb-icon *ngIf="icon" [style.fontSize.px]="iconSize" [icon]="icon" pack="icomoon" class="button-icon primary-button-icon"> </nb-icon>
      <p class="button-text" [style.fontSize.px]="fontSize">
        {{ 'view_translations.' + buttonText | translate }}
        <span *ngIf="timer">({{timer}})</span>
      </p>
    </div>
  </button>
</div>
